import path from 'path'

const DJANGO_URL = window.location.pathname.split('/').slice(0, 4).join('/')

export let routePaths = {
  root: DJANGO_URL,
  canvas: path.join(DJANGO_URL, 'canvas'),
  canvasSetup: path.join(DJANGO_URL, 'canvas', 'setup'),
  canvasAuthorize: path.join(DJANGO_URL, 'canvas', 'auth'),
  canvasChooseCourse: path.join(DJANGO_URL, 'canvas', 'choose'),
  canvasCreateTool: path.join(DJANGO_URL, 'canvas', 'createtool'),
  canvasReview: path.join(DJANGO_URL, 'canvas', 'review'),
  canvasOptionalActions: path.join(DJANGO_URL, 'canvas', 'optionalactions'),
  blackboard: path.join(DJANGO_URL, 'blackboard'),
  blackboardSetup: path.join(DJANGO_URL, 'blackboard', 'setup'),
  brightspace: path.join(DJANGO_URL, 'brightspace'),
  brightspaceSetup: path.join(DJANGO_URL, 'brightspace', 'setup'),
  brightspaceAssessments: path.join(DJANGO_URL, 'brightspace', 'assessments'),
  brightspaceTest: path.join(DJANGO_URL, 'brightspace', 'test'),
}
